<script lang="ts">
	import add from "@core/assets/icons/add.svg?raw";
	import Formatted from "../common/Formatted.svelte";
	import Icon from "../common/Icon.svelte";
	import Link from "../common/Link.svelte";
	import { ButtonVariant } from "../common/getButtonClass.js";

	interface Props {
		question: string;
		answer: string;
		buttonText?: string;
		buttonHref?: string;
	}

	const { question, answer, buttonText, buttonHref }: Props = $props();

	let open = $state(false);

	function toggle(): void {
		open = !open;
	}
</script>

<div
	class="relative box-border w-full flex flex-col bg-ivory-100 border-2 border-ivory-300 rounded-[2rem] md:rounded-[3rem] lg:rounded-[4rem] xl:rounded-[64px] transition-all duration-500 isolate text-left"
>
	<button
		class="flex justify-between items-center duration-300 transition-all gap-3 md:gap-4 w-full py-4 md:py-6 lg:py-8 xl:py-[42px] pr-4 md:pr-6 lg:pr-8 xl:pr-[48px] pl-4 md:pl-6 lg:pl-8 xl:pl-12"
		onclick={toggle}
		type="button"
		class:pb-4={open}
		class:md:pb-6={open}
		class:xl:pb-8={open}
	>
		<span
			class="font-medium text-sm md:text-[1.5rem] md:leading-[140%] tracking-[0.02em] text-hazelnut-500 text-left flex-1"
		>
			{question}
		</span>
		<span
			class="w-8 h-8 md:w-9 md:h-9 xl:w-10 xl:h-10 bg-copper-20-300 rounded-full flex items-center justify-center z-10 transition-all duration-300 group flex-shrink-0"
		>
			<span
				class="w-5 h-5 md:w-5 md:h-5 xl:w-6 xl:h-6 text-ivory-100 transition-transform duration-300"
				class:rotate-45={open}
			>
				<Icon icon={add} class="w-full h-full" />
			</span>
		</span>
	</button>

	<div
		class="grid overflow-clip pr-4 md:pr-6 lg:pr-8 xl:pr-[48px] pl-4 md:pl-6 lg:pl-8 xl:pl-12 transition-all duration-300 w-full"
		class:grid-rows-[1fr]={open}
		class:grid-rows-[0fr]={!open}
		class:pb-4={open}
		class:md:pb-6={open}
		class:xl:pb-[47px]={open}
	>
		<div class="min-h-0 font-light text-text-mobile md:text-base text-midnight flex flex-col gap-3 md:gap-4">
			<Formatted text={answer} />
			{#if buttonText && buttonHref && open}
				<div class="flex justify-center md:justify-start">
					<Link variant={ButtonVariant.PrimaryMedium} href={buttonHref}>
						{buttonText}
					</Link>
				</div>
			{/if}
		</div>
	</div>
</div>
